<ng-container *ngIf="dispEnable || isSubmit">
  <div *ngIf="dispEnable && _agreementAreaParts.partsTitle" class="p-heading-area01">
    <h2 class="p-heading-area01__title c-heading-2">{{ _agreementAreaParts.partsTitle }}</h2>
  </div>

  <div [id]="id" class="p-terms-conditions">
    <div *ngIf="dispEnable" class="p-terms-conditions__body">
      <h3
        class="p-terms-conditions__title c-text-m c-text-m--bold"
        [innerHTML]="sanitizeHtml(staticMessage.confirmTitle)"
      ></h3>
      <div class="p-terms-conditions__contents">
        <ul *ngFor="let message of dynamicMessage" class="p-terms-conditions__list">
          <li class="p-terms-conditions__list-item" [innerHTML]="sanitizeHtml(dynamicMsgKeyPrefix + message)"></li>
        </ul>
      </div>
    </div>
    <div [ngClass]="{ 'p-terms-conditions__foot': dispEnable }">
      <div *ngIf="dispEnable" class="p-terms-conditions__foot-agree">
        <asw-checkbox
          [label]="staticMessage.consent | staticMsg"
          (change$)="onClickAgreeChecked($event)"
        ></asw-checkbox>
      </div>
      <div class="p-terms-conditions__foot-btn" [style]="isCancelStyle">
        <asw-button id="{{ id }}cancelButton" *ngIf="isCancel" type="secondary" (click$)="cancelEventClick()">
          <span class="c-btn-primary__text">{{ _agreementAreaParts.cancelText }}</span>
        </asw-button>
        <asw-button
          id="{{ id }}submitButton"
          *ngIf="isSubmit"
          (click$)="submitEventClick()"
          [disabled]="dispEnable && !agreeStatus"
        >
          <span class="c-btn-primary__text">{{ _agreementAreaParts.submitText }}</span>
        </asw-button>
      </div>
    </div>
  </div>
</ng-container>
